import QuotationWaitingApprovalComponent from './quotation-waiting-approval';
export default QuotationWaitingApprovalComponent;
